type Args = {
  show: boolean;
};

export function toggleDocumentScroll({ show }: Args) {
  window.document.body.style.overflowY = show ? '' : 'hidden';
}
